const toLine = (value) =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * Writes a skill file: frontmatter with kind, title and description (one line each), any other
 * frontmatter lines the file already had, then the instructions.
 */
const buildSkillDocument = ({ title, description, body, otherLines = ['kind: skill'] }) => {
  const kept = otherLines.some((line) => line.startsWith('kind:')) ? otherLines : ['kind: skill', ...otherLines];
  const [kindLine, ...rest] = [...kept.filter((line) => line.startsWith('kind:')), ...kept.filter((line) => !line.startsWith('kind:'))];
  const lines = [kindLine, `title: ${toLine(title)}`, `description: ${toLine(description)}`, ...rest];
  const text = String(body || '').trim();

  return `---\n${lines.join('\n')}\n---\n${text ? `${text}\n` : ''}`;
};

export default buildSkillDocument;
